// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1Qis5","Open":"SideDrawer_Open__1F_8b","Close":"SideDrawer_Close__1kQHA","DesktopOnly":"SideDrawer_DesktopOnly__SHRo0"};